import React from 'react';
import ReportScreen from '../../src/screens/report/ReportScreen';

export default function ReportRoute() {
  return <ReportScreen />;
}
